export const MAX_MOVE_LIMIT = 100;
export const STATUS = {
  ERROR: "ERROR",
  PROGRESS: "PROGRESS",
  SUCCESS: "SUCCESS",
};
